/**
 * This code is adapted from the `remix-utils` library.
 * @see https://github.com/sergiodxa/remix-utils
 */

import { useSyncExternalStore } from 'react';

export function subscribe() {
  return () => undefined;
}

/**
 * Returns `true` when running in the browser and hydration is complete, `false` otherwise
 *
 * Note: you should consider checking `typeof document !== 'undefined'` instead of
 * doing this if doing so wouldn't cause a SSR mismatch. This hook is only meant
 * to be used when avoiding hydration mismatches is required.
 *
 * In other words, don't use this inside `useEffect` as it's unnecessary.
 *
 * This hook will return `false` both on the server side and while hydrating in the browser.
 * Once hydration is complete, the hook will return `true` and never change again.
 *
 * Components mounted after hydration is complete will skip re-rendering and receive
 * `true` directly on their first render.
 *
 */
export function useHydrated() {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  );
}
